const DATA_LAYER_EVENT_PREFIX = 'dataLayerEvent:';
const PENDING_EVENT_TTL_MS = 5 * 60 * 1000;

const getBrowserWindow = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window;
};

const getStorageKey = (eventKey) => `${DATA_LAYER_EVENT_PREFIX}${eventKey}`;

const getUserData = ({ userEmail, userPhone }) => {
  const userData = {};

  if (userEmail) {
    userData.email_address = userEmail;
  }

  if (userPhone) {
    userData.phone_number = userPhone;
  }

  return userData;
};

export const pushDataLayerEvent = ({
  event,
  userEmail,
  userPhone,
  ecommerce,
  ...metadata
}) => {
  const browserWindow = getBrowserWindow();

  if (!browserWindow || !event) {
    return false;
  }

  browserWindow.dataLayer = browserWindow.dataLayer || [];

  if (ecommerce) {
    browserWindow.dataLayer.push({ ecommerce: null });
  }

  const userData = getUserData({ userEmail, userPhone });
  const payload = {
    event,
    ...metadata,
  };

  if (Object.keys(userData).length > 0) {
    payload.user_data = userData;
  }

  if (ecommerce) {
    payload.ecommerce = ecommerce;
  }

  browserWindow.dataLayer.push(payload);
  return true;
};

export const reserveDataLayerEvent = (eventKey) => {
  const browserWindow = getBrowserWindow();

  if (!browserWindow || !eventKey) {
    return true;
  }

  try {
    const storageKey = getStorageKey(eventKey);
    const existingEvent = browserWindow.localStorage.getItem(storageKey);

    if (existingEvent === 'tracked') {
      return false;
    }

    if (existingEvent) {
      const parsedEvent = JSON.parse(existingEvent);

      if (
        parsedEvent.status === 'pending' &&
        Date.now() - parsedEvent.createdAt < PENDING_EVENT_TTL_MS
      ) {
        return false;
      }
    }

    browserWindow.localStorage.setItem(storageKey, JSON.stringify({
      status: 'pending',
      createdAt: Date.now(),
    }));
    return true;
  } catch (error) {
    return true;
  }
};

export const completeReservedDataLayerEvent = (eventKey, payload) => {
  const didPush = pushDataLayerEvent(payload);
  const browserWindow = getBrowserWindow();

  if (didPush && browserWindow && eventKey) {
    try {
      browserWindow.localStorage.setItem(getStorageKey(eventKey), 'tracked');
    } catch (error) {
      // Tracking has already been pushed; storage failure should not affect UX.
    }
  }

  return didPush;
};

export const releaseReservedDataLayerEvent = (eventKey) => {
  const browserWindow = getBrowserWindow();

  if (!browserWindow || !eventKey) {
    return;
  }

  try {
    const storageKey = getStorageKey(eventKey);
    const existingEvent = browserWindow.localStorage.getItem(storageKey);

    if (existingEvent === 'pending') {
      browserWindow.localStorage.removeItem(storageKey);
      return;
    }

    if (existingEvent) {
      const parsedEvent = JSON.parse(existingEvent);

      if (parsedEvent.status === 'pending') {
        browserWindow.localStorage.removeItem(storageKey);
      }
    }
  } catch (error) {
    // Ignore storage failures; this helper is best-effort.
  }
};
